const revealObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-revealed");
        observer.unobserve(entry.target);
      }
    });
  },
  {
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px",
  },
);

export default {
  mounted(el) {
    el.classList.add("reveal-on-scroll");
    revealObserver.observe(el);
  },
  unmounted(el) {
    revealObserver.unobserve(el);
  },
};
